export default __webpack_public_path__ + "static/SR USA - Application Guia - Color Caramelo Liquido (en inglés)-f622c2dfbf67b8792ea23e5bf15166ef.pdf";